// extracted by mini-css-extract-plugin
module.exports = {"container":"_12459","price":"_2185","unit":"_6826","value":"_3174","cost":"_4006","vertical":"_12921","seckillStyle":"_682"};